import {TPlace} from '../Definitions';

const withinMaybeBounds: (bounds?: google.maps.LatLngBounds, filterIfNoBounds?: boolean) => (place: TPlace) => boolean =
	(bounds, filterIfNoBounds = true) =>
		place =>
			bounds
				? place?.geometry?.location
					? bounds.contains(place.geometry.location)
					: false
				: filterIfNoBounds;

export default withinMaybeBounds;
